import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useDataModification } from 'global/cnr/contexts/useHelpers/useDataModification';
import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Icon, Image, Label, Menu, Popup, Segment, Sidebar } from 'semantic-ui-react';
import { getAuthIcon } from '../auth/authPermissions';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { uniqueKey } from '../common/keys';
import { allPageTypes } from '../enums/allPageTypes';
import { gEnums } from '../enums/globalEnums';
import { PageItemOptionsMenu } from '../sidebars/PageItemOptionsMenu';
import PagePrompt from './PagePrompt';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';

const _showPrompt = false

const _navPairs = {
  districts: {
    path: ['organizations', 'districts'],
    icon: 'map',
  },
  sports: {
    path: ['districts', 'sports'],
    icon: 'trophy',
  },
}
/**
 * 
 * @returns a navigation menu for the app
 */
const PageNavigation = () => {

  const navigate = useNavigate()
  const location = useLocation()

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, page_state, paps_state } = states
  const { pageNav } = page_state ?? {}
  const { navOptions } = pageNav ?? {}
  const { aps_global, aps_viewItems, aps_views, aps_appUserSettings, aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { events: events_aps } = aps_views ?? {}
  const { viewItems: viewItems_events } = events_aps ?? {}
  const { storage_fns } = fns

  // appUserAccess
  const appUserAccess = useAppUserAccess()
  const { appUserSessionKey, appUserSession, accessLevel } = appUserAccess ?? {}
  const { view, pathViews, lastRootPath } = paps_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { desktopMode, homePageCaption } = framework_state ?? {}
  const { handleShow_appBottomSidebar, handleClick_contentItem } = framework_handlers ?? {}
  const desktopView = desktopMode ? true : false

  // pageContext  F
  const { navigation, themedItems, pageOptions, eventOptions, clientOptions, appInstallation } = aps_global ?? {}
  const { navigationItems, includeHome, includeSlideout, homeIconImage, useHomeIconImage, showItemActionInNavigation } = navigation ?? {}
  const { showInNavigation, allowGeoList, allowGeoLocation, allowFeeds, allowImageLinks, allowTwitter, allowVideoLinks } = pageOptions ?? {}
  const _appOptions = { ...clientOptions, ...eventOptions }
  const { showAppUserHistoryInNav } = _appOptions

  const { allowAutoPromptForAppIntallation } = appInstallation ?? {}

  const _showInNavigation = showInNavigation && (allowGeoList || allowGeoLocation || allowFeeds || allowImageLinks || allowTwitter || allowVideoLinks)
  const { appUserCollection, showFavoritesInNavigation, showMyProfileLinkInNavigation, allowChat, showChatInNavigation, allowNotes, showNotesInNavigation } = aps_appUserSettings ?? {}

  const { navigation: navigation_ti } = themedItems ?? {}
  const { iconSize } = navigation_ti ?? {}

  let { showCaptions } = navigation ?? {}

  const { additionalNavigationItems, additionalNavigationPopupItems } = useDataModification()

  const [allowedNavigationItems, setAllowedNavigationItems] = useState()
  const [showPrompt, setShowPrompt] = useState(false);
  const [showPageItemOptions] = useState()
  const [showSomething, setShowSomething] = useState()
  const [selected, setSelected] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [target, setTarget] = useState(null);

  const handleShowSomething = () => setShowSomething(true)

  let additionalNiCount = additionalNavigationItems ? _.size(additionalNavigationItems) : 0
  let additionalPiCount = additionalNavigationPopupItems ? _.size(additionalNavigationPopupItems) : 0

  if (showAppUserHistoryInNav) { additionalNiCount++ }

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}


  const handleGoTo = (opts) => navigate('/' + opts.path)

  const handleMenuItemClick = (item, isAppUser) => {
    const { key, oc, opts } = item ?? {}
    if (oc) {
      oc(opts)
    } else {
      const navProps = { clickedItem: item, isAppUser }
      switch (key) {
        case 'slideout':
          handleClick_contentItem(navProps)
          break;
        default:
          handleClick_contentItem(navProps)
          break;
      }
    }
  }

  const hc = (e, item, isAppUser) => {
    const { key, oc, opts } = item ?? {}
    setSelected(key);
    setTarget(e.currentTarget);
    setPopupOpen(true);
  }

  useEffect(() => {
    if (navigationItems && viewItems_events) {
      const _allowNavigationItems = []
      navigationItems.forEach(navigationItem => {
        if (viewItems_events[navigationItem]) {
          const vie = viewItems_events[navigationItem]
          const { accessManagement } = vie ?? {}
          const { accessLevel: accessLevel_nav } = accessManagement ?? {}
          if (!accessLevel_nav) {
            _allowNavigationItems.push(navigationItem)
          } else {
            if (accessLevel >= accessLevel_nav) {
              _allowNavigationItems.push(navigationItem)
            }
          }
        }
      })
      setAllowedNavigationItems(_allowNavigationItems)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPrompt(true);
    }, 10000); // 10 seconds

    // cleanup if component unmounts
    return () => clearTimeout(timer);
  }, []);

  const handleShowBottomSidebar_additional = () => handleShow_appBottomSidebar(menu_additional)
  const handleShowBottomSidebar_history = () => handleShow_appBottomSidebar(menu_additional)
  const handleShowBottomSidebar_additional_pu = () => handleShowSomething()

  const getPagePath = (name) => {
    let pagePath = ''
    let done = false
    const spl = lastRootPath.split('/')
    spl.forEach(sp => {
      if (sp) {
        if (sp === name) {
          pagePath += sp + '/'
          pagePath += pathViews[name]
          done = true
        } else if (!done) {
          pagePath += sp + '/'
        }
      }
    })
    return pagePath
  }

  const pageNavHome = {
    page: null,
    path: null,
    icon: null,
  }

  if (pathViews) {
    _.forEach(pathViews, pv => {
      if (pv !== view) {
        if (aps_viewItems && aps_viewItems[pv]) {
          const { pageNavigation } = aps_viewItems[pv]
          const { showPageHome, pageHomeIcon } = pageNavigation ?? {}
          if (showPageHome) {
            pageNavHome.path = getPagePath(pv)
            pageNavHome.page = pv
            pageNavHome.icon = pageHomeIcon
          }
        }
      }
    })
  }

  if (desktopView) { showCaptions = true }


  // from view  
  const { layout: layout_page } = aps_page ?? {}
  const { layoutType } = layout_page ?? {}

  const menuSaC = aps_styles ? aps_styles[gEnums.projectStyles.navigation] : {}
  const menuSaC_ai = aps_styles ? aps_styles[gEnums.projectStyles.actionItems] : {}

  if (layoutType === 'icons') { return null }

  const label_nav = (count) => <Label color='blue' floating style={{ top: '-.3em', marginLeft: '-1.8em' }}>{count}</Label>

  const iconOrImage = (item, isAdditional) => {
    const { display, adm } = item ?? {}
    const { icon, iconImage, useIconImage } = display ?? {}
    const iconImageUrls = storage_fns.getIconUrl(useIconImage, iconImage)
    const { urls } = iconImageUrls ?? {}
    const { full, thumbnail } = urls ?? {}
    const src = thumbnail ? thumbnail : full
    const { name, color } = icon ?? {}
    let _iconColor = color ? color : null
    if (adm) {
      _iconColor = 'red'
    }
    let _size = iconSize ? iconSize : null
    if (isAdditional) { _size = null }
    if (src) {
      return <Image src={src} alt={iconImage} className={'icon-image'} />
    } else {
      if (name) {
        return <Icon size={_size} name={name.trim()} color={_iconColor} />
      } else {
        return <Icon size={_size} name={'file alternate'} />
      }
    }
  }

  const iconLabel = (item, count) => {
    const { icon } = item.display ?? {}
    const { name } = icon ? icon : {}
    return <React.Fragment>
      <Icon name={name} />
      <Label circular attached='top right' color={'green'} size={'tiny'} >
        {count}
      </Label>
    </React.Fragment>
  }

  const navMenuItem = (item, il, count, isAppUser, isAdditional) => {

    // IMPORTANT: match the key with the view so that the item will be active    
    let lbl = null

    const { messageCount, key, index, display, label, forPoup } = item ?? {}
    const { caption } = display ?? {}

    if (messageCount && (messageCount > 0)) { lbl = label_nav(messageCount) }
    if (label) { lbl = label }

    return <Menu.Item
      key={uniqueKey('pn', 'mi', key, index)}
      name={key}
      active={key === paps_state.viewAs}
      // onClick={(e) => { hc(e, item, isAppUser) }}
      onClick={(e) => { forPoup ? hc(e, item, isAppUser) : handleMenuItemClick(item, isAppUser) }}
    >
      {!il && iconOrImage(item, isAdditional)}
      {il && iconLabel(item, count)}
      {(showCaptions || isAdditional) && lbl}
      {(showCaptions || isAdditional) && caption && _.startCase(caption)}
    </Menu.Item>
  }

  const xxx = (a) => {
    a?.oc && a.oc(a.opts)
  }

  const menu_additional = useMemo(() => {
    // return <div>TEST</div>
    console.log('additionalNavigationItems', additionalNavigationItems)
    if (!additionalNavigationItems) return []
    return <ItemMenuSquares
      onClick={xxx}
      caption={'Options'}
      icon={'options'}
      // menuItems={{ name: 'TEST' }}
      menuItems={additionalNavigationItems}
      imsType={_imsTypes.inline}
    />
  }, [additionalNavigationItems])

  const pu = () => <div
    style={{
      width: '100%',
      backgroundColor: 'var(--off-black-2)',
      posistion: 'absolute',
      left: 0,
      right: 0,
      bottom: '400px',
      padding: '1em'
    }}>
    <ItemMenuSquares
      onClick={xxx}
      caption={'Sports'}
      icon={'trophy'}
      menuItems={additionalNavigationPopupItems}
      imsType={_imsTypes.inline}
      style={{ height: '400px', overflowY: 'auto' }}
    />
  </div>

  const menu_additional_pu = () => {
    if (!additionalNavigationPopupItems) return []
    return <ItemMenuSquares
      onClick={xxx}
      caption={'Sports'}
      icon={'trophy'}
      menuItems={additionalNavigationPopupItems}
      imsType={_imsTypes.inline}
      style={{ height: '400px', overflowY: 'auto' }}
    />
  };

  const altNavItems = (mis) => {
    const lastTwoKeys = _.takeRight(_.keys(pathViews), 2)
    _.forEach(_navPairs, ({ path, icon }, caption) => {
      if (_.isEqual(lastTwoKeys, path)) {
        let _path;
        const parts = location.pathname.split('/').filter(Boolean)
        const idx = parts.lastIndexOf(path[0])
        if (idx !== -1 && parts[idx + 1]) {
          _path = '/' + parts.slice(0, idx + 2).join('/')
        }
        mis.push(
          navMenuItem({
            key: 'alt',
            display: {
              icon: { name: icon },
              caption,
            },
            oc: handleGoTo,
            opts: { path: `${_path}` }
          })
        )
      }
    })
  }

  const menuItems = useMemo(() => {

    const mis = []

    if (includeSlideout && !desktopView) {
      mis.push(navMenuItem({ key: 'slideout', display: { icon: { name: 'content' }, caption: 'options' } }))
    }

    if (includeHome) {
      mis.push(navMenuItem({
        key: paps_state.landingView,
        display: {
          icon: { name: 'home' },
          caption: paps_state.appHome,
          iconImage: homeIconImage,
          useIconImage: useHomeIconImage
        }
      }))
    }

    if (allowedNavigationItems) {
      allowedNavigationItems.forEach((item, index) => {
        let allow = true
        const vi = aps_viewItems && aps_viewItems[item] ? aps_viewItems[item] : {}
        const { display } = vi ?? {}
        const { defaultIcon } = display ?? {}
        const icon = { name: defaultIcon }
        if (allow) {
          mis.push(navMenuItem({ index, key: item, display: { ...display, icon } }))
        }
      })
    }

    // this is the page/district/org, etc.
    if (pageNavHome.page) {
      const vi = aps_viewItems?.[pageNavHome.page] || {}
      const { display } = vi ?? {}
      const _display = homePageCaption ? { ...display, caption: homePageCaption } : display
      mis.push(navMenuItem({
        key: pageNavHome.page,
        display: { ..._display, icon: { name: pageNavHome.icon } },
        opts: pageNavHome,
        oc: handleGoTo
      }))
    }

    if (showFavoritesInNavigation) {
      mis.push(navMenuItem({ key: allPageTypes.favorites, display: { icon: { name: 'star outline' }, caption: 'Favorites' } }))
    }

    if (showMyProfileLinkInNavigation && appUserSessionKey && appUserSession) {
      const icon = getAuthIcon(appUserAccess ? appUserAccess.accessLevel : 0)
      mis.push(navMenuItem({ key: appUserCollection, display: { icon: { ...icon, color: null }, caption: 'appUser' } }, null, null, true))
    }

    if (allowNotes && showNotesInNavigation) {
      mis.push(navMenuItem({ key: allPageTypes.notes, display: { icon: { name: 'edit outline' }, caption: 'Notes' } }))
    }

    if (allowChat && showChatInNavigation) {
      mis.push(navMenuItem({ key: allPageTypes.chat, display: { icon: { name: 'conversation' }, caption: 'Chat' } }))
    }

    if (showItemActionInNavigation && navOptions) {
      mis.push(navMenuItem({ key: allPageTypes.navOptions, display: { icon: { name: 'options' }, caption: 'Options' } }))
    }

    if (_showInNavigation) {
      mis.push(navMenuItem({ key: allPageTypes.media, display: { icon: { name: 'newspaper outline' }, caption: 'Media' } }))
    }

    altNavItems(mis)

    if (additionalNiCount > 0) {
      mis.push(navMenuItem({ key: 'more', forPoup: false, oc: handleShowBottomSidebar_additional, display: { icon: { name: 'options' }, caption: 'More' } }))
      if (showAppUserHistoryInNav) {
        mis.push(navMenuItem({ key: 'appUserHistory', oc: handleShowBottomSidebar_history, display: { icon: { name: 'history' }, caption: 'History' } }))
      }
    }

    // if (additionalPiCount > 0) {
    //   mis.push(navMenuItem({ key: 'sports', oc: handleShowBottomSidebar_additional_pu, display: { icon: { name: 'trophy' }, caption: 'Sports' } }))
    //   count++
    // }

    return {
      count: _.size(mis),
      items: mis
    }
  }, [
    includeSlideout,
    includeHome,
    allowedNavigationItems,
    pageNavHome,
    showFavoritesInNavigation,
    showMyProfileLinkInNavigation,
    showNotesInNavigation,
    showChatInNavigation,
    showItemActionInNavigation,
    _showInNavigation,
    additionalNiCount
  ])

  const fpw_navOptions = () => <PageItemOptionsMenu />

  const styAndC = Object.assign({}, menuSaC)

  const menu = () => {

    const navItems = menuItems

    // const menu = <Menu
    //   {...styAndC}
    //   inverted
    //   icon={showCaptions ? 'labeled' : null}
    //   widths={!desktopView && navItems.count}
    //   key={uniqueKey('pn', 'm')} >
    //   {navItems.items}
    // </Menu>

    return <>
      <Menu
        {...styAndC}
        inverted
        icon={showCaptions ? 'labeled' : null}
        widths={!desktopView && navItems.count}
        key={uniqueKey('pn', 'm')} >
        {navItems.items}
      </Menu>
      {target && (
        pu()
      )}
    </>
  }

  const content = () => {
    if (!includeSlideout && !includeHome && !allowedNavigationItems) {
      return <Segment basic inverted>
        {'No bottom menus set'}
      </Segment>
    } else {
      if (showPageItemOptions) {
        return fpw_navOptions()
      } else {
        if (_showPrompt && showPrompt) {
          return <div>
            <PagePrompt />
            {menu()}
          </div>
        } else {
          return menu()
        }
      }
    }
  }

  return content()

}

export default PageNavigation
